import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EditBusinessItem from "./EditBusinessItem";
import {
  getBusinessItemList,
  getDropdownData,
  updateItemRequest,
  fetchBrandAndHsn
} from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({
  dropdownData: state.businessItemReducer.dropdownData,
  businessItemData: state.businessItemReducer.businessItemList,
  brandAndHsnData: state.businessItemReducer.brandAndHsnData, 
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getBusinessItemList,
      getDropdownData,
      updateItemRequest,
      fetchBrandAndHsn
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditBusinessItem);
